export default function passwordValidator(password) {
  const re = /^(?=^.{8,}$)(?=.*[A-Z])(?=.*\d).*$/;
  return re.test(password);
}
